/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Root_Error_Boundary_Reload_LabelInputs */

const en_components_root_error_boundary_reload_label = /** @type {(inputs: Components_Root_Error_Boundary_Reload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload App`)
};

const de_components_root_error_boundary_reload_label = /** @type {(inputs: Components_Root_Error_Boundary_Reload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`App neu laden`)
};

const pt_br2_components_root_error_boundary_reload_label = /** @type {(inputs: Components_Root_Error_Boundary_Reload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recarregar app`)
};

const tr_components_root_error_boundary_reload_label = /** @type {(inputs: Components_Root_Error_Boundary_Reload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uygulamayı yeniden yükle`)
};

const zh_cn2_components_root_error_boundary_reload_label = /** @type {(inputs: Components_Root_Error_Boundary_Reload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新加载应用`)
};

const zh_hk2_components_root_error_boundary_reload_label = /** @type {(inputs: Components_Root_Error_Boundary_Reload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新載入應用程式`)
};

const ko_kr2_components_root_error_boundary_reload_label = /** @type {(inputs: Components_Root_Error_Boundary_Reload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`앱 새로고침`)
};

const ru_ru2_components_root_error_boundary_reload_label = /** @type {(inputs: Components_Root_Error_Boundary_Reload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перезагрузить приложение`)
};

const es_419_components_root_error_boundary_reload_label = /** @type {(inputs: Components_Root_Error_Boundary_Reload_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recargar la aplicación`)
};

/**
* | output |
* | --- |
* | "Reload App" |
*
* @param {Components_Root_Error_Boundary_Reload_LabelInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const components_root_error_boundary_reload_label = /** @type {((inputs?: Components_Root_Error_Boundary_Reload_LabelInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Root_Error_Boundary_Reload_LabelInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_components_root_error_boundary_reload_label(inputs)
	if (locale === "de") return de_components_root_error_boundary_reload_label(inputs)
	if (locale === "pt-BR") return pt_br2_components_root_error_boundary_reload_label(inputs)
	if (locale === "tr") return tr_components_root_error_boundary_reload_label(inputs)
	if (locale === "zh-CN") return zh_cn2_components_root_error_boundary_reload_label(inputs)
	if (locale === "zh-HK") return zh_hk2_components_root_error_boundary_reload_label(inputs)
	if (locale === "ko-KR") return ko_kr2_components_root_error_boundary_reload_label(inputs)
	if (locale === "ru-RU") return ru_ru2_components_root_error_boundary_reload_label(inputs)
	return es_419_components_root_error_boundary_reload_label(inputs)
});